import axios from 'axios'

export default {

  async ACTION_LOGIN({ commit }, credentials) {},

  async ACTION_LOGOUT({ commit }, logoutData) { },


  SET_LAYOUT({ commit }, routeName) {
    let layoutValue = null;
    switch (routeName) {
      case 'dashboard':
      default:
        layoutValue = 'desktop-layout';
        break;
      case 'login':
        layoutValue = 'login-layout';
        break;
      case 'patient':
        layoutValue = 'desktop-layout';
        break;
        case 'forgot-password':
        layoutValue = 'forgot-password';
        break;
        case 'set-password':
        layoutValue = 'update-password-layout';
    }
    commit('setLayout', layoutValue);
  },

  async httpPost({ commit }, options) {
    try {
      let reqParams = {
        method: 'POST',
        url: options.url,
        data: options.data,
        headers: options.headers
      }
      let response = await axios(reqParams)
      if (response && response.data)
        return response.data;
      return null;
    } catch (e) {
      console.log("error in calling http post call", e);
    }
  },
  async dateFormat({ commit }, options) {
    try {
      return moment(options.date).format(options.format)
    } catch (e) {
      return "";
    }
  },
  SET_DASHBOARD_TITLE({ commit }, title) {
    commit('setDashboardTitle', title)
  },
  SET_MENU_DATA({ commit }, data) {
      commit('SET_MENU_DATA', data)
  },
  SET_ACTION_TYPE({ commit }, data) {
    commit('SET_ACTION_TYPE', data)
  },

  SET_OFFICE_ID({ commit }, data) {
    commit('SET_OFFICE_ID', data)
  },

  SET_H_TYPE({ commit }, data) {
    commit('SET_H_TYPE', data)
  },

  SET_CURRENCY({ commit }, data) {
    commit('SET_CURRENCY', data)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js